// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from "axios";
import moment from 'moment'
import App from './App';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store/index'
import "./plugins/vuetify-mask.js";
import "@/assets/css/site.css"
import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV)
Vue.config.productionTip = false;
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});
Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm')
  }
});
Vue.filter('formatTime', function(value) {
  if (value) {
    return moment(String(value)).format('hh:mm:ss:SSS')
  }
});
Vue.filter('dateUtcToLocal', function(value) {
  if (value) {
    const [dateValue,zone] = value.split("T")
    return  moment(dateValue).format('MM/DD/YYYY');
  }
});


/*
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // token expired
    if (error.response.status === 401) {
      delete localStorage.token;
      router.push({ name: "Login" });
    }
  }
);
*/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  vuetify,
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js